import { useEffect, useState } from "react";
import API from "../services/api";

export default function Salary() {
  const [staffId, setStaffId] = useState("");
  const [amount, setAmount] = useState("");
    const [month, setMonth] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [staffList, setStaffList] = useState([]);
    const [description, setDescription] = useState("");
    const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split("T")[0]);
    const [paymentMode, setPaymentMode] = useState("");
    const [referenceNo, setReferenceNo] = useState("");
    const [notes, setNotes] = useState("");

    useEffect(() => {

        const loadStaff = async () => {

            try {

                const res = await API.get("/staff");

                setStaffList(res.data);

            } catch (err) {

                console.log("Unable to load staff", err);

            }

        };

        loadStaff();

    }, []);


    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePayment = async () => {

        if (isSubmitting) {
            return;
        }

        try {

            setIsSubmitting(true);


            /* =========================
               BASIC VALIDATION
            ========================= */

            if (!paymentType) {
                alert("Please select a payment type.");
                return;
            }

            if (paymentType === "Salary" && !staffId) {
                alert("Please select a staff member.");
                return;
            }

            if (paymentType === "Salary" && !month) {
                alert("Please select the salary month.");
                return;
            }

            if (
                !amount ||
                Number(amount) <= 0
            ) {
                alert("Please enter a valid amount.");
                return;
            }

            if (
                paymentType !== "Salary" &&
                !description.trim()
            ) {
                alert("Please enter the expense description.");
                return;
            }

            if (!paymentDate) {
                alert("Please select the payment date.");
                return;
            }

            if (!paymentMode) {
                alert("Please select the payment mode.");
                return;
            }


            /* =========================
               GET ACADEMIC YEAR
            ========================= */

            let academicYear = "";

            try {

                const yearRes =
                    await API.get(
                        "/settings/active-academic-year"
                    );

                academicYear =
                    yearRes.data.academic_year || "";

            } catch (err) {

                console.log(
                    "Unable to fetch active academic year",
                    err
                );

            }


            /* =========================
               SALARY
            ========================= */

            if (paymentType === "Salary") {

                await API.post(
                    "/salary/pay",
                    {
                        staff_id: staffId,
                        amount,
                        month,
                        payment_date: paymentDate,
                        payment_mode: paymentMode,
                        reference_no: referenceNo,
                        notes,
                        academic_year: academicYear
                    }
                );

                alert(
                    "Salary payment recorded successfully"
                );

            }


            /* =========================
               OTHER EXPENSE
            ========================= */

            else {

                await API.post(
                    "/salary/expense",
                    {
                        expense_type: paymentType,
                        description,
                        amount,
                        payment_date: paymentDate,
                        payment_mode: paymentMode,
                        reference_no: referenceNo,
                        notes,
                        academic_year: academicYear
                    }
                );

                alert(
                    "Expense recorded successfully"
                );

            }


            /* =========================
               RESET FORM
            ========================= */

            setStaffId("");
            setAmount("");
            setMonth("");
            setPaymentType("");
            setDescription("");
            setPaymentDate(
                new Date()
                    .toISOString()
                    .split("T")[0]
            );
            setPaymentMode("");
            setReferenceNo("");
            setNotes("");


        } catch (err) {

            console.log(err);

            const message =
                err?.response?.data?.message;


            if (message) {

                alert(message);

            } else if (paymentType === "Salary") {

                alert(
                    "Salary payment failed"
                );

            } else {

                alert(
                    "Expense recording failed"
                );

            }

        } finally {

            setIsSubmitting(false);

        }

    };
   

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
              Salary & Expense Entry
      </h1>

      <div className="bg-white shadow p-6 rounded">

              <div className="mb-4">

                  <label className="block mb-2 font-semibold">
                      Payment Type <span className="text-red-600">*</span>
                  </label>

                  <select
                      value={paymentType}
                      onChange={(e) =>
                          setPaymentType(e.target.value)
                      }
                      className="border p-2 w-full rounded"
                  >

                      <option value="">
                          Select Payment Type
                      </option>

                      <option value="Salary">
                          Salary
                      </option>

                      <option value="Food">
                          Food / Meals
                      </option>

                      <option value="Furniture">
                          Benches / Furniture
                      </option>

                      <option value="Electricity">
                          Electricity Bill
                      </option>

                      <option value="Gas">
                          Gas Bill
                      </option>

                      <option value="Water">
                          Water Bill
                      </option>

                      <option value="Maintenance">
                          Maintenance / Repairs
                      </option>

                      <option value="Transport">
                          Transport
                      </option>

                      <option value="Books">
                          Books / Stationery
                      </option>

                      <option value="Other">
                          Other Expense
                      </option>

                  </select>

              </div>

              {paymentType === "Salary" && (

                  <div className="mb-4">

                      <label className="block mb-2 font-semibold">
                          Staff <span className="text-red-600">*</span>
                      </label>

                      <select
                          value={staffId}
                          onChange={(e) =>
                              setStaffId(e.target.value)
                          }
                          className="border p-2 w-full rounded"
                      >
                          <option value="">
                              Select Staff
                          </option>

                          {staffList.map((staff) => (
                              <option
                                  key={staff.id}
                                  value={staff.id}
                              >
                                  {staff.name} - {staff.role}
                              </option>
                          ))}

                      </select>

                  </div>

              )}

              {paymentType === "Salary" && (

                  <div className="mb-6">

                      <label className="block mb-2 font-semibold">
                          Salary Month <span className="text-red-600">*</span>
                      </label>

                      <input
                          type="month"
                          value={month}
                          onChange={(e) =>
                              setMonth(e.target.value)
                          }
                          className="border p-2 w-full rounded"
                      />

                  </div>

              )}

              {paymentType && paymentType !== "Salary" && (

                  <div className="mb-6">

                      <label className="block mb-2 font-semibold">
                          Expense Description{" "}
                          <span className="text-red-600">*</span>
                      </label>

                      <input
                          type="text"
                          placeholder="Enter expense description"
                          value={description}
                          onChange={(e) =>
                              setDescription(e.target.value)
                          }
                          className="border p-2 w-full rounded"
                      />

                  </div>

              )}


              <div className="mb-6">

                  <label className="block mb-2 font-semibold">
                      Amount <span className="text-red-600">*</span>
                  </label>

                  <input
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) =>
                          setAmount(e.target.value)
                      }
                      className="border p-2 w-full rounded"
                  />

              </div>

              <div className="mb-6">

                  <label className="block mb-2 font-semibold">
                      Payment Date <span className="text-red-600">*</span>
                  </label>

                  <input
                      type="date"
                      value={paymentDate}
                      onChange={(e) =>
                          setPaymentDate(e.target.value)
                      }
                      className="border p-2 w-full rounded"
                  />

              </div>

              <div className="mb-6">

                  <label className="block mb-2 font-semibold">
                      Payment Mode <span className="text-red-600">*</span>
                  </label>

                  <select
                      value={paymentMode}
                      onChange={(e) =>
                          setPaymentMode(e.target.value)
                      }
                      className="border p-2 w-full rounded"
                  >

                      <option value="">
                          Select Payment Mode
                      </option>

                      <option value="Cash">
                          Cash
                      </option>

                      <option value="Bank Transfer">
                          Bank Transfer
                      </option>

                      <option value="UPI">
                          UPI
                      </option>

                      <option value="Cheque">
                          Cheque
                      </option>

                      <option value="Card">
                          Card
                      </option>

                      <option value="Other">
                          Other
                      </option>

                  </select>

              </div>

              <div className="pt-2">

                  <button
                      type="button"
                      onClick={handlePayment}
                      disabled={isSubmitting}
                      className="bg-green-600 text-white px-4 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                      {paymentType === "Salary"
                          ? "Record Salary Payment"
                          : "Record Expense"}
                  </button>

              </div>
      </div>
    </div>
  );
}